import { useMemo } from "react";
import { useTypedSelector } from "./useTypedSelector";
import { hasPluginConfigChanges } from "../utils/pluginConfigChangeDetector";
import { hasXPathConfigChanges } from "../utils/xpathConfigChangeDetector";
import { hasPushbackConfigChanges } from "../utils/pushbackConfigChangeDetector";
import { hasDocumentBundlingChanges, hasEventBundlingChanges } from "../utils/bundlingConfigChangeDetector";

export const useHasUnsavedChanges = () => {
    const configData = useTypedSelector((state) => state.configPlugInData.data?.Configuration);
    const persistedConfig = useTypedSelector((state) => state.configPlugInData.persistedData?.Configuration);
    const xPathData = useTypedSelector((state) => state.xPathData.data);
    const persistedXPathData = useTypedSelector((state) => state.xPathData.persistedData);
    const pushbackData = useTypedSelector((state) => state.configPushbackDefaults.data);
    const persistedPushbackData = useTypedSelector((state) => state.configPushbackDefaults.persistedData);
    const documentBundles = useTypedSelector((state) => state.configDocumentBundles.data);
    const persistedDocumentBundles = useTypedSelector((state) => state.configDocumentBundles.persistedData);
    const eventBundles = useTypedSelector((state) => state.configEventBundles.data);
    const persistedEventBundles = useTypedSelector((state) => state.configEventBundles.persistedData);

    return useMemo(() => {
        const pluginChanged = configData && persistedConfig
            ? hasPluginConfigChanges(configData, persistedConfig)
            : false;
        const xpathChanged = xPathData && persistedXPathData
            ? hasXPathConfigChanges(xPathData, persistedXPathData)
            : false;
        const pushbackChanged = pushbackData && persistedPushbackData
            ? hasPushbackConfigChanges(pushbackData, persistedPushbackData)
            : false;
        const documentBundlingChanged = documentBundles && persistedDocumentBundles
            ? hasDocumentBundlingChanges(documentBundles, persistedDocumentBundles)
            : false;
        const eventBundlingChanged = eventBundles && persistedEventBundles
            ? hasEventBundlingChanges(eventBundles, persistedEventBundles)
            : false;
        return pluginChanged || xpathChanged || pushbackChanged || documentBundlingChanged || eventBundlingChanged;
    }, [
        configData,
        persistedConfig,
        xPathData,
        persistedXPathData,
        pushbackData,
        persistedPushbackData,
        documentBundles,
        persistedDocumentBundles,
        eventBundles,
        persistedEventBundles
    ]);
};
